import React from 'react'
import MaterialSymbol from '../material-symbol'

const Schedule = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="schedule" {...props} />
))

Schedule.displayName = 'Schedule'

export default Schedule
